module.exports = __webpack_public_path__ + "media/fonts/icons-1ab236ed.ttf";